import type { ListQuestionDescriptor } from '../list-question-utils';
import {
  getListPageExcelColumnFieldName,
  getListPageExcelColumns,
  getListPageExcelColumnTitle,
} from './columns';

const TEMPLATE_SIGNATURE_PREFIX = 'GRID_LIST_TEMPLATE_V1';

const hashTemplateSchema = (schema: string) => {
  let hash = 2166136261;
  for (let index = 0; index < schema.length; index += 1) {
    hash ^= schema.charCodeAt(index);
    hash = Math.imul(hash, 16777619);
  }
  return (hash >>> 0).toString(16).padStart(8, '0');
};

export const getListPageExcelTemplateSignature = ({
  tenant,
  pageName,
  descriptors,
}: {
  tenant: string;
  pageName: string;
  descriptors: ListQuestionDescriptor[];
}) => {
  const columns = getListPageExcelColumns(descriptors);
  const schema = JSON.stringify({
    tenant,
    pageName,
    columns: columns.map((column) => ({
      title: getListPageExcelColumnTitle(column),
      fieldName: getListPageExcelColumnFieldName(column),
      descriptors: column.descriptors.map((descriptor) => ({
        name: descriptor.question.name,
        questionType: descriptor.question.questionType,
        kind: descriptor.kind,
        rules: descriptor.question.rules,
        wordCount: descriptor.question.wordCount,
        characterCount: descriptor.question.characterCount,
        options: descriptor.options,
        conditions: descriptor.conditions,
      })),
    })),
  });
  return `${TEMPLATE_SIGNATURE_PREFIX}:${hashTemplateSchema(schema)}`;
};
